import { useEffect, useState } from "react";
import { Check, X } from "lucide-react";
import { getVoiceProfile, voiceProfiles } from "../../config/voiceProfiles";
import "./VoicePickerDialog.css";

export default function VoicePickerDialog({ onClose, onSelect, open, selectedVoice }) {
  const [draftVoice, setDraftVoice] = useState(() => getVoiceProfile(selectedVoice).value);

  useEffect(() => {
    if (!open) return undefined;

    setDraftVoice(getVoiceProfile(selectedVoice).value);
    const previousOverflow = document.body.style.overflow;
    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };

    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose, open, selectedVoice]);

  if (!open) return null;

  const confirmSelection = () => {
    onSelect(draftVoice);
    onClose();
  };

  return (
    <div className="voice-picker-overlay" role="presentation">
      <button
        aria-label="Close voice picker"
        className="voice-picker-backdrop"
        onClick={onClose}
        type="button"
      />
      <section
        aria-labelledby="voice-picker-title"
        aria-modal="true"
        className="voice-picker-dialog"
        role="dialog"
      >
        <div className="voice-picker-handle" aria-hidden="true" />
        <div className="voice-picker-header">
          <div>
            <h2 id="voice-picker-title">Choose a voice</h2>
            <p>Select who you would like to practice with.</p>
          </div>
          <button
            aria-label="Close voice picker"
            className="voice-picker-close"
            onClick={onClose}
            type="button"
          >
            <X size={20} />
          </button>
        </div>

        <div aria-label="Available voices" className="voice-picker-options" role="radiogroup">
          {voiceProfiles.map((profile) => {
            const selected = profile.value === draftVoice;
            return (
              <button
                aria-checked={selected}
                className={`voice-picker-option ${selected ? "is-selected" : ""}`.trim()}
                key={profile.value}
                onClick={() => setDraftVoice(profile.value)}
                role="radio"
                type="button"
              >
                <span className="voice-picker-image-wrap">
                  <img alt="" decoding="async" src={profile.image} />
                  {selected ? (
                    <span className="voice-picker-check" aria-hidden="true">
                      <Check size={18} strokeWidth={3} />
                    </span>
                  ) : null}
                </span>
                <strong>{profile.label}</strong>
                <span>{profile.description}</span>
              </button>
            );
          })}
        </div>

        <button className="voice-picker-done" onClick={confirmSelection} type="button">
          Done
        </button>
      </section>
    </div>
  );
}
